module.exports = __webpack_public_path__ + "img/pclogoicon.1cca0249.webp";